export default __webpack_public_path__ + "static/media/newbanner2.c5d93d62.png";